import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatTooltipModule } from '@angular/material/tooltip';
import { RouterModule } from '@angular/router';
import { HemroDrawerModule } from '@hemro/components/drawer';
import { TranslocoModule } from '@jsverse/transloco';
import { SettingsComponent } from 'app/layout/common/settings/settings.component';


@NgModule({
    declarations: [
        SettingsComponent,
    ],
    imports     : [
        CommonModule,
        RouterModule,
        MatIconModule,
        MatTooltipModule,
        HemroDrawerModule,
        MatButtonModule,
        TranslocoModule,
    ],
    exports     : [
        SettingsComponent,
    ],
})
export class SettingsModule
{
}
